<template>
        <main class="ps-page--my-account">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">
                  <li v-if="isEnglish()==true"><a href="/#/private">Home</a></li>
                  <li v-if="isEnglish()==false"><a href="/#/private">Acceuil</a></li>
                  <li v-if="isEnglish()==true" >User Information</li>
                  <li v-if="isEnglish()==false" >Informations de l'utilisateur</li>
                </ul>
            </div>
        </div>
        <section class="ps-section--account">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="ps-section__left">
                            <aside class="ps-widget--account-dashboard">
                                <div class="ps-widget__header"><img src="img/users/3.jpg" alt="">
                                    <figure>
                                        <figcaption>Hello</figcaption>
                                        <p><a href="#">{{user_email}}</a></p>
                                    </figure>
                                </div>
                               <side-menu :lang="lang" :userde_state="userde_state"></side-menu>
                </aside>
                        </div>
                    </div>
                    <div class="col-lg-8">


                      <div class="ps-section__right">
                            <form class="ps-form--account-setting" >
                                <div class="ps-form__header">
                                   <div v-if="sent" class="alert alert-success" role="alert">
                                        {{msg}}
                                     </div>
                                       <div  v-if="failed" class="alert alert-danger" role="alert">
                                            {{ msg }}
                                        </div>
                                    <h3 v-if="isEnglish()==true"> User Information</h3>
                                    <h3 v-if="isEnglish()==false"> Informations de l'utisateur</h3>
                                </div>
                                <div class="ps-form__content">
                                    <div class="form-group">
                                        <label v-if="isEnglish()==true">Name</label>
                                        <label v-if="isEnglish()==false">Nom</label>
                                        <input class="form-control" type="text" v-model="user.name">
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label v-if="isEnglish()==true">Company</label>
                                                 <label v-if="isEnglish()==false">Compagnie</label>
                                                <input class="form-control" type="text" v-model="user.company_name" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input class="form-control" type="text" v-model="user.email" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Role</label>
                                                <input class="form-control" type="text" v-model="user.role_id" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">

                                            </div>
                                        </div>
                                    </div>
                                    <br/><br/><br/>
                                      <div class="row">
                                    <div class="col-sm-6">
                                         <div class="form-group submit">
                                         <button v-if="isEnglish()==true" class="ps-btn" type="button" v-on:click="update_info()">Update</button>
                                         <button v-if="isEnglish()==false" class="ps-btn" type="button" v-on:click="update_info()">Sauvegarder</button>

                                       </div>
                                    </div>
                                </div>
                                </div>


                            </form>


                             <br/><br/><br/><br/>
                            <div>

                                 <form class="ps-form--account-setting" >
                                <div class="ps-form__header">
                                      <div v-if="sent2" class="alert alert-success" role="alert">
                                        {{msg}}
                                     </div>
                                       <div  v-if="failed2" class="alert alert-danger" role="alert">
                                            {{ msg }}
                                        </div>
                                    <h3 v-if="isEnglish()==true">Change Password</h3>
                                    <h3 v-if="isEnglish()==false">Changer mot de passe</h3>
                                </div>
                                <div class="ps-form__content">
                                    <div class="form-group">
                                        <label v-if="isEnglish()==true">Current Password</label>
                                        <label v-if="isEnglish()==false">Mot de passe Actuel</label>
                                        <input class="form-control" type="password" v-model="change_pass.password">
                                    </div>
                                    <div class="form-group">
                                        <label v-if="isEnglish()==true"> New Password</label>
                                        <label v-if="isEnglish()==false"> Nouveau mot de passe</label>
                                        <input class="form-control" type="password" v-model="change_pass.newpassword">
                                    </div>
                                    <div class="form-group">
                                        <label v-if="isEnglish()==true">Confirm Password</label>
                                        <label v-if="isEnglish()==false">Confirmez mot de passe</label>
                                        <input class="form-control" type="password" v-model="change_pass.confirmpass">
                                    </div>

                                    <br/><br/><br/>
                                    <div class="row">
                                    <div class="col-sm-6">
                                         <div class="form-group submit">
                                         <button v-if="isEnglish()==true" v-on:click="change_password()" type="button" class="ps-btn">Submit</button>
                                         <button v-if="isEnglish()==false" v-on:click="change_password()" type="button" class="ps-btn">Envoyer</button>
                                       </div>
                                    </div>
                                </div>
                                </div>


                            </form>
                            </div>
                     </div>



                    </div>
                </div>
            </div>
        </section>

    </main>
</template>

<script>
 import DataService from "@/services/DataService";
 import SideMenu from './SideMenu.vue';

export default {
  name: 'Userdetails',
  components: {
    'side-menu': SideMenu
  },
  props: ['search_on','search_obj','language'],
  data () {
    return {
        userde_state:"active",
        msg: '',
        token :localStorage.getItem('token'),
        user_email: localStorage.getItem('email'),
        failed:false,
        failed2:false,
        lang : this.language,
        sent: false,
        sent2:false,
        arrived:false,
        caller_role:localStorage.getItem('caller_role'),
        change_pass:{password:"",newpassword:"",confirmpass:""},
        user:{},
    }
  },

   methods:{

      get_user_details(){
        var dataa = {};
        this.failed = false;

        console.log("printing the dataa before sending");
        console.log(dataa);
        DataService.get_user_details(dataa,this.token)
          .then(response => {

            console.log(response);
            this.user = response.data;


          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){
              this.msg = "Resource nod found";
            }else if(e.response.status == 401){
             this.$router.push('/login');
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }
            this.failed = true;

          });
      },

      change_password(){
        var dataa = this.change_pass;
        this.failed2 = false; this.failed = false;
        this.sent2 = false;  this.sent = false;

        console.log("printing the dataa before sending");
        console.log(dataa);

        if(this.change_pass.newpassword == this.change_pass.confirmpass){


           DataService.change_password(dataa,this.token)
          .then(response => {

            console.log(response);
            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.change_pass = {password:"",newpassword:"",confirmpass:""};
            this.sent2 = true;

          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){

              this.msg = "Resource nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }
            this.failed2 = true;

          });
        }else{
          this.change_pass.confirmpass = "";

          if(this.isEnglish()){
              this.msg = "Sorry,New password does not match confirmation.";
          }else{
              this.msg = "Désolé, le nouveau mot de passe ne correspond pas à la confirmation.";
          }

          this.failed2 = true;

        }

      },

      update_info(){

        var dataa = this.user;
        this.failed = false;  this.failed2 = false;
        this.sent = false;  this.sent2 = false;

        console.log("printing the dataa before sending");
        console.log(dataa);
        DataService.update_user_details(dataa,this.token)
          .then(response => {

          console.log(response);
          this.msg = this.$parent.translate_error_message(response.data,"message");
          this.sent = true;

          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){

              this.msg = "Resource nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = e.response.data.errors[0];
            }else {
              this.msg = "Please check your internet.";
            }
            this.failed = true;

          });

      },

      isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

      },

   },


    watch: {

      search_on:function(){
        console.log("value of search_on is :"+this.search_on);


        if(this.search_on){

          //this.search_user_products(this.search_obj);
           //this.$parent.search_on = false;
           this.$router.push('/products');

        }

        console.log(this.search_obj);
      },

      language:function(){
        this.lang = this.language;
        console.log("language value has changed in private component");
        //this.language = this.lang ;
      },

},


    created(){
      console.log("printimg loggedin value in created :"+this.$parent.loggedin);
      console.log("printimg token value in created :"+this.$parent.token);
    },



    mounted(){

      console.log("printimg loggedin value in invitation mounted :"+this.$parent.loggedin);
      console.log("printimg token value in invitation mounted :"+this.$parent.token);


      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login');
      }else{

        if(localStorage.getItem('caller_role')=='Basic'){

          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
          this.get_user_details();

        }else{
          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
           this.get_user_details();
        }

      }
    }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Userdetails.vue